import { useEffect } from "react";
import { NotifyCard, NotifyOverlay, notifyBtn } from "../../components/NotifyCard";

// GOOD: 2 short rising beeps. BAD: 3 long low beeps.
const playResultBeep = (good) => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const notes = good ? [[880, 0, 0.15], [1320, 0.2, 0.25]] : [[220, 0, 0.4], [220, 0.55, 0.4], [220, 1.1, 0.6]];
    notes.forEach(([f, at, dur]) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = good ? "sine" : "square"; o.frequency.value = f;
      const t = ctx.currentTime + at;
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.3, t + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g).connect(ctx.destination); o.start(t); o.stop(t + dur + 0.05);
    });
    setTimeout(() => ctx.close(), 2500);
  } catch { /* audio unavailable */ }
};

const played = new WeakSet();

const KIND_TEXT = {
  eeprom: { good: "WRITE EEPROM SUKSES", bad: "WRITE EEPROM GAGAL", okMsg: "Matikan lalu nyalakan kunci kontak.", badMsg: "Cek log, lalu ulangi." },
  count: { good: "CLEAR FLASH COUNT SUKSES", bad: "CLEAR FLASH COUNT GAGAL", okMsg: "Matikan lalu nyalakan kunci kontak.", badMsg: "Matikan lalu nyalakan kunci kontak, lalu ulangi." },
};

export const FlashResultDialog = ({ result, onClose }) => {
  useEffect(() => { if (result && !played.has(result)) { played.add(result); playResultBeep(result.ok); } }, [result]);
  if (!result) return null;
  const good = result.ok;
  const k = KIND_TEXT[result.kind];
  const title = k ? (good ? k.good : k.bad) : (good ? "RESULT GOOD" : "RESULT BAD");
  const message = k ? (good ? k.okMsg : `${k.badMsg}${result.result ? ` (${result.result})` : ""}`)
    : (good ? "Flash selesai. Matikan kunci kontak lalu nyalakan lagi (restart ECU)." : `Flash gagal (${result.result}). Jangan cabut kabel, cek log lalu ulangi flash.`);
  return (
    <NotifyOverlay testid="flash-result-overlay" onClose={k ? undefined : onClose}>
      <NotifyCard type={good ? "success" : "error"} testid={good ? "flash-result-good" : "flash-result-bad"}
        title={title} message={message}
        actions={<button data-testid="flash-result-ok" onClick={(e) => { e.stopPropagation(); onClose(); }} className={notifyBtn.ok}>{k ? "Tutup" : "OK"}</button>}>
        {result.file && !k && <div data-testid="flash-result-file" className="mt-2 truncate text-[13px] text-slate-400">{result.file}</div>}
        {result.seconds != null && <div data-testid="flash-result-duration" className="text-[13px] text-slate-400">Waktu: {result.seconds}s</div>}
      </NotifyCard>
    </NotifyOverlay>
  );
};
